<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader 
            ref="actionHeader" 
            v-on:filterChange="onFilterChange" 
            v-on:newItem="onNewItem"
            :newButton="$UIPrivilegeC('realtime/vehicles')">>
          </TableActionHeader>
          <GroupCallButton :recipients="groupCallRecipients"/>
          <VehicleTable 
            :filter="filter" 
            v-on:selectItem="onSelectItem"
            @filteredRows="onVehicleTableFiltered" 
            :showCallButtons="true" 
            :showLinkToVehicleOnMapButton="$UiConfig('/ui/actions/showLinkToVehicleOnMap', true)">
          </VehicleTable>
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
           <CardHeader :title="$t('item.new')"/>
             <VehicleForm :item="item" :action="action" v-on:updateItem="onItemUpdated" />                  
        </card>
        <card v-if="action == 'item' && item">
          <CardHeader :title="item ? item.id: ''" type="item" />
          <VehicleForm :item="item" :action="action" v-on:updateItem="onItemUpdated"></VehicleForm>                  
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import VehicleTable from '@/components/Realtime/VehicleTable.vue'
import VehicleForm from '@/components/Realtime/VehicleForm.vue'
import GroupCallButton from '@/components/Dispatching/VoIP/GroupCallButton'

export default {
    name: 'Vehicles',
    components: {
        VehicleTable, VehicleForm, TableActionHeader, CardHeader,GroupCallButton
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            item: {
                "vehicleLabel": null,
                "computerLabel": null,
                "organisation": null,
                "features":[]
            },
            action: "",
            groupCallRecipients: []
        }
    },
    mounted: function() {
      if(this.$route.query.vehicleLabel) {
        this.filter = this.$route.query.vehicleLabel;
        this.$refs.actionHeader.setFilterValue(this.filter);
      }

    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = null;        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = item;
            this.action = "item"        
        },
        onSelectItem: function(item) {
            this.item = item ? JSON.parse(JSON.stringify(item)) : {};            
            this.action = item ? "item" : "";
        },
        onVehicleTableFiltered: function( event ) {
          this.groupCallRecipients = event.filter( vehicle => {
            return vehicle?.features['SIP_CLIENT_ID']  } )
            .map( vehicle => vehicle.features['SIP_CLIENT_ID'])
           
        }

    }
}
</script>
